export default __webpack_public_path__ + "static/media/playbtn.818e3b92.svg";